const maxDiscount = 0.93; // 8% off for volume orders

function updatePriceRange() {
  const variantSelector = document.querySelector('select[name="id"], input[name="id"]:checked, [data-selected-variant]');
  
  if (!variantSelector) return;
  
  const selectedVariantId = variantSelector.value || variantSelector.dataset.selectedVariant;
  
  // Make sure productJson exists
  if (typeof productJson === 'undefined') return;
  
  const variantData = productJson.variants.find(v => v.id == selectedVariantId);
  
  if (variantData) {
    const fullPrice = variantData.price;
    const discountedPrice = Math.round(fullPrice * maxDiscount);
    
    const priceRangeLow = document.querySelector('.price-range__low');
    const priceRangeHigh = document.querySelector('.price-range__high');
    
    if (priceRangeLow && priceRangeHigh) {
      priceRangeLow.textContent = formatMoney(discountedPrice);
      priceRangeHigh.textContent = formatMoney(fullPrice);
    }
  }
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

// Listen for variant changes - Horizon uses custom events
document.addEventListener('variant:change', updatePriceRange);

// Fallback for standard selects
document.addEventListener('change', function(e) {
  if (e.target.matches('select[name="id"], input[name="id"]')) {
    updatePriceRange();
  }
});

// Run on page load if a variant is pre-selected
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updatePriceRange);
} else {
  updatePriceRange();
}
